export default __webpack_public_path__ + "static/media/task-icon.ec22c126.svg";